import management from '../../management/.config/redux/reducers'
import client from '../../client/.config/redux/reducers'

//export redux objects
export default {
	...management,
	...client
};
